// extracted by mini-css-extract-plugin
module.exports = {"Socials":"Socials_Socials__o5Ctk","slideIn":"Socials_slideIn__3xryr","enable":"Socials_enable__Vfh6m"};